import { useMutation, useQueryClient } from '@tanstack/react-query';
import { usePrismAuth } from '@/lib/prism-bridge';
import { generateApiKey, type GeneratedApiKey } from './apiKeys';
import { queryKeys } from './queryKeys';

/**
 * Generates (replaces) the developer's API key via POST /dev-portal/api-keys.
 * The plaintext key is returned exactly once — the caller must surface it
 * immediately (it can never be retrieved again). On success we invalidate the
 * has-key status so the page flips to the "key active" state once the reveal
 * modal is dismissed.
 */
export function useGenerateApiKey() {
  const { token, orgId } = usePrismAuth();
  const queryClient = useQueryClient();

  return useMutation<GeneratedApiKey>({
    mutationFn: () => generateApiKey({ token, orgId }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.apiKeys.status(orgId) });
    },
  });
}
